import { get } from 'app/common/helpers/fetch';
import { getConsumerId } from 'app/common/helpers/cookie';

const sessionStorageKey = 'verifiedUser';

function saveSession(user) {
  if (user && user.id) {
    try {
      sessionStorage.setItem(sessionStorageKey, JSON.stringify(user));
      } catch (__) {} // eslint-disable-line
  }
  return user;
}

export function removeSession() {
  try {
    sessionStorage.removeItem(sessionStorageKey);
  } catch (__) {} // eslint-disable-line
}

/**
 * Get authed user from session storage
 */
export const getUserFromStorage = () => {
  let user = null;
  try {
    const userData = sessionStorage.getItem(sessionStorageKey);
    user = JSON.parse(userData);
    if (!user.id) {
      user = null;
    }
  } catch (__) {} // eslint-disable-line

  return user;
};

export function fetchUser() {
  return get('/layout/calls/users/v1').then(user => saveSession(user));
}

export function loadUser() {
  // check snickerdoodle cookie first
  if (!getConsumerId()) {
    return Promise.resolve(null);
  }

  // load data from session storage second
  const user = getUserFromStorage();
  if (user) {
    return Promise.resolve(user);
  }

  return fetchUser();
}
